export function Footer() {
  return (
    <footer className="border-t border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900">
      <div className="mx-auto max-w-5xl px-4 py-5 flex flex-col sm:flex-row items-center justify-between gap-2">
        <span className="text-sm font-semibold text-slate-900 dark:text-slate-100">Айгентура</span>
        <a href="tel:+74951234567" className="text-xs text-slate-400 dark:text-slate-500 hover:text-slate-600 dark:hover:text-slate-300 transition-colors">+7 (495) 123-45-67</a>
        <span className="text-xs text-slate-400 dark:text-slate-500">© {new Date().getFullYear()} Все права защищены</span>
      </div>
    </footer>
  );
}
